import React, { useEffect, useState, useRef } from 'react';

import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { CHARTCOLORS } from '../../globals/Globals';
import { useTheme } from '@mui/material';

interface Props {
    series: {name: string, data: number[];}[];
    title: string;
    categories: string[];
    showtitle?:string;
    type?:string;
}

interface ChartOptions {
    chart: { type:string; backgroundColor: string; };
    title: { text?: string, style: object; };
    series: {data: ChartSeries[]}[] | {data:number[], name: string}[] | ChartSeries[] | { data: ChartSeries };
    xAxis: { categories: string[], title: { text:string}, labels: object};
    yAxis: { title: { text: string}, labels: object};
    legend: { itemStyle: object };
}

interface ChartSeries {
    data: number[] | [name:string, value:number];
    name: string;
    y?: number;
    tooltip?: object;
    baseLabel?:string;
}


const MultiSeriesGraph = ({series, title, categories, showtitle, type, tooltip=null, baseLabel="Rounds"}: Props) => {
    const theme = useTheme();
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
    const [ seriesData, setSeriesData ] = useState<{name:string, data:number[]}[]>(series);
    if (!type) {
        type = 'line';
    }
    let options:ChartOptions = {
        chart: { 
            type:type,
            backgroundColor: theme.palette.mode === 'dark' ? '#121212' : "white",
        },
        title: {
            text: showtitle,
            style: {
                color: theme.palette.mode === 'dark' ? 'white' : "black",
            }
        },
        series: series,
        xAxis: {
            categories: categories,
            title: {
                text: baseLabel
            },
            labels: {
                style: { 
                    color: theme.palette.mode === 'dark' ? 'white' : "black",
                }
            }
        },
        yAxis: {
            title: {
                text: ''
            },
            labels: {
                style: { 
                    color: theme.palette.mode === 'dark' ? 'white' : "black",
                }
            }
        },
        legend: {
            itemStyle: {
                color: theme.palette.mode === 'dark' ? 'white' : "#121212",
            }
        },
        
    }
    if (tooltip) {
        options['tooltip'] = tooltip;
    }
    
    

    useEffect(() => {
        setSeriesData(series);
    },[])

    useEffect(() => {
        setSeriesData(series);
    },[series])
    if (typeof Highcharts === 'object'){
        Highcharts.setOptions({
            colors: CHARTCOLORS
        })
    }
    console.log("Options: ", options);
    return (<div>
        <HighchartsReact
            ref={chartComponentRef}
            highcharts={Highcharts}
            options={options}
            updateArgs={[true, true, true]}
            oneToOne={true} 
        />
    </div>)
}

export default MultiSeriesGraph;